import { render, staticRenderFns } from "./deposit-limits-settings.vue?vue&type=template&id=355208ed"
import script from "./deposit-limits-settings.vue?vue&type=script&lang=js"
export * from "./deposit-limits-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports